import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserService } from '@api/custom-services/user.service';
import { Authority } from '@api/models';
import { difference, isArray } from 'lodash-es';
import { SubscriptionDirective } from './subscriptions.directive';

@Directive({
   selector: '[hasAuthorities]',
   standalone: true,
})
export class HasAuthoritiesDirective extends SubscriptionDirective implements OnInit {
   @Input('hasAuthorities') authorities?: Authority[] | Authority;

   constructor(
      private templateRef: TemplateRef<any>,
      private viewContainer: ViewContainerRef,
      private userService: UserService
   ) {
      super();
   }

   ngOnInit() {
      this.subs = this.userService.user$.subscribe({
         next: (result) => {
            const requiredAuthorities = isArray(this.authorities) ? this.authorities : [this.authorities];
            if (difference(requiredAuthorities, result.authorities).length === 0) {
               this.viewContainer.createEmbeddedView(this.templateRef);
            } else {
               this.viewContainer.clear();
            }
         },
      });
   }
}
